module.exports = "https://web-assets.ifttt.com/packs/media/layout/chevron-up-white-a936a9b0.svg";